const priceInfoArr = [
  {
    label: '医生服务',
    key: 'serviceAttribution'
  },
  {
    label: '图文咨询服务',
    key: 'doctorDefaultConsultFeeConfigList',
    type: 'graphic',
    itemStyle: {
      alignItems: 'baseline'
    },
    valueStyle: {
      textAlign: 'right'
    }
  },
  {
    label: '电话咨询服务',
    key: 'doctorPhoneDefaultConsultFeeConfigList',
    type: 'phone',
    itemStyle: {
      alignItems: 'baseline'
    },
    valueStyle: {
      textAlign: 'right'
    }
  },
  {
    label: '视频咨询服务',
    key: 'doctorVideoDefaultConsultFeeConfigList',
    type: 'video',
    itemStyle: {
      alignItems: 'baseline'
    },
    valueStyle: {
      textAlign: 'right'
    }
  },
  {
    label: '按患者设置图文咨询',
    key: 'thisPatientChargeString'
  },
  // {
  //   label: '默认问诊费',
  //   key: 'defaultCharge'
  // },
  {
    label: '患者首次咨询免费',
    key: 'firsCureFree'
  }
  // {
  //   label: '医生发起问诊默认免费',
  //   key: 'doctorAddCureFree'
  // },
]

// 医生备案状态 0:未申请备案，1:备案审核中，2:备案成功，3:备案失败"
const docRecordStatus = {
  0: {
    label: '待认证'
  },
  1: {
    label: '备案审核中'
  },
  2: {
    label: '备案成功'
  },
  3: {
    label: '备案失败'
  }
}

// 认证状态0:待审核,1:审核通过,2:审核不通过3:再次申请审核;4:资料未提交;5:资料未完善
const docAuthStatus = {
  0: {
    label: '待审核'
  },
  1: {
    label: '审核通过'
  },
  2: {
    label: '审核不通过'
  },
  3: {
    label: '再次申请审核'
  },
  4: {
    label: '待审核'
  },
  5: {
    label: '资料未完善'
  }
}

export { priceInfoArr, docRecordStatus, docAuthStatus }
